/**
 * Driver Information base dto. Abstract class used only in inheritance.
 */
export abstract class DriverInformationBaseDto {
  /**
   * Driver ID coming from the Delivery Partner system.
   * Think about it like a `SQL Foreign Key`.
   */
  driverId: number;

  /**
   * Driver last name.
   */
  abstract driverLastName?: string;

  /**
   * Driver contact phone number.
   */
  abstract driverPhoneNumber?: string;
}
